// Shared React helpers for assistant work that must remain visible on the owning page.
function usePageOwnedAutoSubmit(enabled: boolean, submit: () => unknown) {
  const started = React.useRef(false)
  const latest = React.useRef(submit)
  latest.current = submit
  React.useEffect(() => {
    if (!enabled || started.current) return
    started.current = true
    void Promise.resolve().then(() => latest.current())
  }, [enabled])
}

function useRegistryPageIntent(kind: string, applyIntent: (intent: any) => void) {
  const latest = React.useRef(applyIntent)
  latest.current = applyIntent
  React.useEffect(() => {
    const apply = () => {
      const intent = window.PlummeRegistryLiveControl?.consumePageIntent?.(kind)
      if (intent) latest.current(intent)
    }
    window.addEventListener('plumme-registry-page-intent', apply)
    apply()
    return () => window.removeEventListener('plumme-registry-page-intent', apply)
  }, [kind])
}

Object.assign(globalThis, { usePageOwnedAutoSubmit, useRegistryPageIntent })
